export default {
  modal: 999,
  actionBar: 10,
  actionBarItem: 12,
  topNavBar: 20,
  sidebar: 20,
  datePickerPopup: 20,
  flashMessage: 30,
};
